module.exports = __webpack_public_path__ + "static/media/apti_offered_affu.f4393c02.png";